import React from 'react'
import '../App.css'

const Thanks = () => {
    return (
        <div className="Thanks-area">
            <h2>Thank You 🙏</h2>
            <a href="/" className="btn btn-primary">Back To Home</a>
        </div>
    )
}
export default Thanks